
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private landingInfo!: any
  @Prop() private customDcps!: any
  @Prop() private scrollTop!: number
  @Prop({default: () => { return [] } }) private navBars!: Array<any>
  
  /// data
  private data: Object = {}
  private heightlightBar: string = ''
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }

  private get bars(): Array<any> {
    if(this.navBars && this.navBars.length) {
      return this.navBars;
    }
    var titleList = []
    if(this.landingInfo && this.landingInfo.customizedLp){
      // 品牌
      // 产品
      // 资质
      // 流转
      let {custom} = this.landingInfo.activity
      custom.textplain_013 && titleList.push({value: custom.textplain_013, code: 1})
      custom.textplain_015 && titleList.push({value: custom.textplain_015, code: 2})
      custom.textplain_011 && this.customDcps.length && titleList.push({value: custom.textplain_011, code: 3})
      custom.textplain_017 && this.landingInfo.trackinfo && titleList.push({value: custom.textplain_017, code: 4})
      return titleList
    }
    if(this.landingInfo && this.landingInfo.sku){
      titleList.push({value: this.$t('app.product_info'), code: 1})
    }
    if(this.landingInfo && this.landingInfo.activity){
      titleList.push({value: this.$t('app.show_info'), code: 2})
    }
    if(this.customDcps && this.customDcps.length){
      titleList.push({value: this.$t('app.meterial_head'), code: 3})
    }
    if(this.landingInfo && this.landingInfo.trackinfo){
      titleList.push({value: this.$t('app.track_head'), code: 4})
    }
    return titleList
  }

  private selectBar(bar: any) {

      this.heightlightBar = bar
      this.$forceUpdate()
      if(this.navBars && this.navBars.length) {
        this.$emit("selectBar", bar);
        console.log("select_bar", bar);
        return
      }

      setTimeout(()=>{

        let barItems = document.querySelectorAll('.switch-bar-container .bar-item')
        let cardItems = document.querySelectorAll('.card-nav-item')
        let totalScroll = document.body.scrollTop

        let heighlightBar = document.querySelectorAll('.switch-bar-container .bar-item.heighlight')
        
        for (let i = barItems.length - 1; i >= 0; i--) {
            if (heighlightBar[0] === barItems[i]) {
                totalScroll = (cardItems[i] as any).offsetTop - 64
            }
        }
        
        document.documentElement.scrollTop = totalScroll
        document.body.scrollTop = totalScroll
      }, 100)
      this.$emit("selectBar", bar);
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    // if(!this.navBars || this.navBars.length <= 0){
    //   this.heightlightBar = '商品信息'
    // }else{
    //   this.heightlightBar = 
    // }
    this.heightlightBar = this.bars[0]
    // console.log("sku_", this.landingInfo.sku)
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }

  @Watch('scrollTop', {immediate: true})
  onScroll(newVal: number, oldVal: number){

    let cardItems = document.querySelectorAll('.card-nav-item')
    
    for (let i = cardItems.length - 1; i >= 0; i--) {
        let itemOffset = (cardItems[i] as any).offsetTop - 64
        if (newVal >= itemOffset) {

          let heighlightItem = this.bars[i]
          this.heightlightBar = heighlightItem
          this.$forceUpdate()
          break
        }
    }
  }
}
